import { Collapse, Typography } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import React, { useState } from 'react'

import { getTranslate } from '../../../localization'
import { Reference } from '../../../types/walletReferences'
import MetaDataRow from './MetaDataRow'
import useStyles from './styles/ReferenceRow'

interface ReferenceRowProps {
  reference: Reference
  //   showMetaData: boolean
  //   setshowMetaData: React.Dispatch<React.SetStateAction<boolean>>
}

const ReferenceRow: React.FC<ReferenceRowProps> = ({
  reference
  //   setshowMetaData,
  //   showMetaData
}) => {
  const classes = useStyles()
  const [showMetaData, setshowMetaData] = useState<boolean>(false)

  return (
    <>
      <div className={classes.root}>
        <div>
          <Typography variant="body1">{reference.type}</Typography>
        </div>
        <div>
          <Typography variant="body1">{reference.displayId}</Typography>
        </div>
        <div className={classes.metadataButton}>
          <Typography
            variant="h6"
            className={classes.numberOfRatePlans}
            component="span"
            onClick={() => setshowMetaData(!showMetaData)}>
            {reference.metadata.length} {getTranslate('Metadata')}
          </Typography>
          <div className={classes.ratePlansLoading}>
            <ArrowRightIcon
              onClick={() => setshowMetaData(!showMetaData)}
              className={[
                classes.channelArrowRight,
                showMetaData ? classes.channelArrowRightCollapsed : ''
              ].join(' ')}
            />
          </div>
        </div>
      </div>

      <Collapse in={showMetaData}>
        {reference.metadata.map((metadata) => (
          <MetaDataRow
            key={metadata.value + metadata.key}
            metadata={metadata}
          />
        ))}
      </Collapse>
    </>
  )
}
export default ReferenceRow
